import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/SEO'
import PageHeader from '../components/PageHeader'
import { PageContent } from '../styles/author.styles'
import ContainedButton from '../components/ContainedButton'

export default function AboutPage() {
  return (
    <Layout>
      <SEO title="Careers" pathname={`/careers/`} />
      <PageHeader
        title={`Careers`}
        desc={`Be a part of the content you love!`}
      />
      <PageContent>
        <h1>Careers</h1>
        <p>
          Let us know if you are interested in being a writer with us!
          <ContainedButton>Join our Discord Server!</ContainedButton>
        </p>
      </PageContent>
    </Layout>
  )
}
